import React, { useEffect, useRef, useState } from 'react'
import { useNewsTypeUpdateQuery, useNewsTypeUpdateSaveMutation } from '../../store/ReactWebSiteApi';
import { Form, Input, message, Modal } from 'antd';
import MyEditor from '../../cpn/MyEditor';

function NewsTypeEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState();
    const editForm = useRef()
    const {data,isSuccess} = useNewsTypeUpdateQuery({ent_id:props.ent_id},{skip:!open})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                // console.log(data);
                editForm.current.setFieldsValue({
                    ent_name:data.Result.ent_name,
                    ent_content:data.Result.ent_content,
                })
                setInfo(prevState=>({...prevState,
                    ent_name:data.Result.ent_name,
                    ent_content:data.Result.ent_content,
                }))
            }
        }
    },[data,isSuccess])
    const [submitUpdateSave] = useNewsTypeUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {
                setOpen(true)
            }}>修改</a>
            <Modal
                open={open}
                title='修改新闻类型'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                width={800}
                onOk={() => {

                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    submitUpdateSave({
                        ent_name:info.ent_name,
                        ent_content:info.ent_content,
                        ent_e_id:localStorage.getItem('e_id'),
                        ent_update_uid:localStorage.getItem('eu_id'),
                        ent_update_uname:localStorage.getItem('eu_name'),
                        ent_id:props.ent_id,
                    }).then((res) => {
                        console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >
                    <Form.Item name="ent_name" label='名称' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,ent_name:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="ent_content" label='备注' wrapperCol={{span:20}}>
                        <MyEditor  onChange={(e) => {setInfo(prevState=>({...prevState,ent_content:e}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default NewsTypeEdit